export const isrPaths = ['/'];
